import { StyleSheet } from 'react-native';
// SLEEPIO-2657 Fix hoverable types (get rid of unknown below)
export const flattenStyles = (style: unknown) =>
  Array.isArray(style) ? StyleSheet.flatten(style || {}) : style;
